import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Whitespace from '../../../components_new/common/Whitespace';
import Text from '../../../components_new/common/Text';
import Button from '../../../components_new/common/FormComponents/Button';
import { Separator } from '../../../components_new/Separator';
import reportListingMFn from './reportListingMFn';

@observer
class ReportModal extends React.Component {
  @observable selected = null;
  @observable isDone = false;
  offenses = [
    'Harassment',
    'Hate speech',
    'Innacurate Info',
    'Intellectual Property',
    'Nudity',
    'Sales or Sidestepping',
    'Scam / Fake',
    'Violence',
  ];

  sendReport = async () => {
    await reportListingMFn(this.props.listId, this.selected);
    this.isDone = true;
  };

  render() {
    if (this.isDone) {
      return (
        <div className="f-cc bg-white p-mxx f-rows">
          <Whitespace smaller />
          <Text className="t-h4 f-1">Thanks</Text>
          <Whitespace smaller />
          <Text>Report submitted</Text>
          <Whitespace smaller />
          <Button primary onClick={this.props.close}>
            Done
          </Button>
        </div>
      );
    }
    return (
      <div className="bg-white p-mxx">
        <div className="f-self-stretch f-between-center f-columns">
          <Text className="h6">Give feedback on this listing</Text>
          <i className="fal fa-times grayDark" onClick={this.props.close} />
        </div>
        <Separator />
        <div>
          <Text>Help us understand what's going on {this.selected}</Text>
          <Whitespace smaller />
          <div className="f-start-start f-wrap f-self-stretch f-columns">
            {this.offenses.map(x => (
              <div
                className={`btn btn-muted b-primary b-1 mx-s my-sxx
              ${this.selected === x ? 'bg-primary' : ''}`}
                onClick={() => (this.selected = x)}
              >
                <Text key={x}>{x}</Text>
              </div>
            ))}
          </div>
        </div>
        <Separator />
        <Text noclip>
          If this is a dangerous situation please call your local emergency
          services.
        </Text>
        <Separator />
        <div className="f-columns-reverse">
          <Button secondary onClick={this.sendReport}>
            Send
          </Button>
        </div>
      </div>
    );
  }
}

export default ReportModal;



// WEBPACK FOOTER //
// ./src/routes/presentation/Details/ReportModal.js